import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillEye, AiFillDelete } from "react-icons/ai";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/pathObj";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { BsArrowUpShort } from "react-icons/bs";
import helpers from "../../utils/helpers";

const ManageList = ({ jobsList, allJobs, page, handleEdit, handleView, sort, setSort, handleDeleteJob }) => {
  const notification = useToastContext();
  const { t } = useTranslation();

  const handelStatusChange = async (item) => {
    // Only allow status change if job is accepted by admin
    if (item?.adminStatus !== "accepted") {
      notification.error("Job must be accepted by admin before you can change its status");
      return;
    }

    try {
      const payload = {
        status: item?.companyStatus === "active" ? "inactive" : "active",
      };
      const path = `${apiPath.jobsStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allJobs();
      }
    } catch (error) {
      console.log("error in get all jobs list==>>>>", error.message);
    }
  };

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  Sr no.
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("JOB_TITLE")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_COUNTRY")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_STATE")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_CITY")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("CATEGORY")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("SUBCATEGORY")}
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("CREATED_DATE")}</span>
                    <span>
                      {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_ADMINSTATUS")}
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_STATUS")}
                </th>

                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {jobsList &&
                jobsList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.Country?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.State?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.city}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.Category?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.subCategory?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900 text-left">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>

                      <td className="py-4 px-6 border-r text-gray-900 text-center">
                        {item?.status === "accepted" ? (
                          <label className="inline-flex relative items-center cursor-pointer" title={`${item?.companyStatus === "active" ? "Active" : "Inactive"}`}>
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={item?.companyStatus === "active"}
                              onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
                            />
                            <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                          </label>
                        ) : (
                          <span
                            className={`px-2 py-1 rounded-full text-xs ${
                              item?.adminStatus === "accepted"
                                ? "bg-green-100 text-green-800"
                                : item?.adminStatus === "rejected"
                                ? "bg-red-100 text-red-800"
                                : "bg-yellow-100 text-yellow-800" // Default for pending or no data
                            }`}
                          >
                            {item?.adminStatus ? item.adminStatus.charAt(0).toUpperCase() + item.adminStatus.slice(1) : "Pending"}
                          </span>
                        )}
                      </td>

                      <td className="py-4 px-6 border-r text-gray-900 text-center">
                        {item?.adminStatus !== "accepted"  ? (
                          <span  className={`px-2 py-1 rounded-full text-xs ${
                              item?.adminStatus === "accepted"
                                ? "bg-green-100 text-green-800"
                                : item?.adminStatus === "rejected"
                                ? "bg-red-100 text-red-800"
                                : "bg-yellow-100 text-yellow-800" // Default for pending or no data
                            }`}>
                            {item?.adminStatus ? item.adminStatus.charAt(0).toUpperCase() + item.adminStatus.slice(1) : "Pending"}
                          </span>
                        ) : (
                          <label className="inline-flex relative items-center cursor-pointer" title={`${item?.status === "active" ? "Active" : "Inactive"}`}>
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={item?.status === "active"}
                              onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
                            />
                            <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                          </label>
                        )}
                      </td>
                      <td className="py-4 px-6 border-l text-gray-900">
                        <div className="">
                          <ul className="flex justify-center">
                            <li onClick={() => handleEdit(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <a title="Edit" className="hover:text-blue-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
                                {" "}
                                <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                              </a>
                            </li>
                            <li onClick={() => handleView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <a title="View">
                                {" "}
                                <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                              </a>
                            </li>
                            <li onClick={() => {
                              helpers.alertFunction(
                                `Are you sure want to delete '${item.name}'?`,
                                item._id,
                                handleDeleteJob,
                                true
                              );
                            }}
                            className="px-2 py-2 hover:bg-white hover:text-red-500" >
                              <a title="Delete">
                                <AiFillDelete className="cursor-pointer w-5 h-5 text-slate-600" />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(jobsList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={11}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageList;